<template>
  <div class="component-container">
    <template v-if="isSearchView">
      <div class="band-title-wrap">
        <h3 class="component-title" tabindex="0">{{sectionInfo.title}}</h3>
        <span class="search-result-number" :aria-label="'검색 결과 ' + sectionInfo.count + '건'">{{sectionInfo.count}}</span>
        <a href="#" @click.prevent="goMoveTab" class="link-band-list" :aria-label="'검색 결과 ' + sectionInfo.count + '건 모두보기'">{{sectionInfo.count}}</a>
      </div>
    </template>
    <template v-else>
      <div class="band-title-wrap">
        <h3 class="component-title" tabindex="0">{{sectionInfo.title}}</h3>
      </div>
    </template>
  </div>
</template>

<script>
import { bandTitle } from '@/common/directives'
import { getTypeCodeFromTitleString } from '@/common/util/common'
import { PATH_NAME_SEARCH } from '@/common/router.const'
import { get } from 'lodash'
import { sendEventLogSearchResultEditorPickViewAll } from '@/common/util/log.v2.send'
import { stringify } from 'query-string'

export default {
  name: 'TitleOnly',
  props: { sectionInfo: { type: Object } },
  data () {
    return {
      isSearchView: true
    }
  },
  directives: {
    bandTitle
  },
  methods: {
    goMoveTab () {
      const sectionTitle = this.sectionInfo.title === '에피소드' ? 'VOD' : this.sectionInfo.title
      const type = getTypeCodeFromTitleString(sectionTitle)
      const mType = type === 'movie' ? sectionTitle === '영화플러스' ? 'ppv' : 'svod' : 'all'
      const query = {
        searchCategory: type,
        searchWord: get(this.$route, 'query.searchWord', ''),
        mType: mType
      }

      sendEventLogSearchResultEditorPickViewAll({
        landingUrl: `${PATH_NAME_SEARCH}?${stringify(query)}`
      })
      this.$router.push({
        name: PATH_NAME_SEARCH,
        query
      })
    }
  },
  created () {
    this.isSearchView = this.$route.name === 'search'
  }
}
</script>
